import { format } from "date-fns";

export const getFormattedDateWithHoursMinutes = (timestamp: number, event_type?: number): any => {
  // event_type: 2 is all day offers
  const formatType = event_type === 2 ? "dd.MM.yyyy" : "dd.MM.yyyy / HH:mm";

  return format(new Date(timestamp * 1000), formatType);
};
